// extracted by mini-css-extract-plugin
export var card = "styles-module--card--5af7f";
export var clientsImage = "styles-module--clientsImage--4371b";
export var container = "styles-module--container--016d7";
export var content = "styles-module--content--a5bc4";
export var dismissIcon = "styles-module--dismissIcon--90ac0";
export var hexLeft = "styles-module--hexLeft--325db";
export var hexRight = "styles-module--hexRight--d28ab";
export var modal = "styles-module--modal--50aff";